export default {
    namespaced: true,
    state: {
        routes: []
    },
    mutations: {
        addRoute(state, {url, uuid}) {
            state.routes.push({url, uuid})
        },
        removeRoute(state, uuid) {
            const itemToRemoveIndex = state.routes.findIndex( item => item.uuid === uuid );
              if (itemToRemoveIndex) {
                 state.routes.splice(itemToRemoveIndex, 1);
              }
        }
    },
    actions: {
        addRoute({commit}, payload) {
            commit('addRoute', {url: payload.url, uuid: payload.uuid})
        }
    },
    getters: {
        getRoutes(state) {
            return state.routes
        },
        getRouteByUrl: (state) => (url) => {
            return state.routes.find(route => route.url === url)
        }
    },
}
